import { Box, Heading, Text } from "@vinomofo/components";

import { usePlanContext } from "../../hooks/wine-clubs/use-plan-context";
import { SelectorOption } from "./SelectorOption";

export const PreferenceSelector = (): JSX.Element => {
  const {
    preference: selectedPreference,
    preferenceOptions,
    changePreference,
    club,
  } = usePlanContext();

  if (!preferenceOptions) return null;

  return (
    <Box>
      <Box textAlign="center" mb={4}>
        <Heading as="h3" variant="sm" textAlign="center" color={"white"}>
          Personalise to taste
        </Heading>
      </Box>
      <Box display="flex">
        {preferenceOptions.map((preference, index) => {
          return (
            <SelectorOption
              key={index}
              onClick={() => changePreference(preference)}
              isSelected={preference === selectedPreference}
              activeColor={club.color}
            >
              <Text color="white">{preference.label}</Text>
            </SelectorOption>
          );
        })}
      </Box>
    </Box>
  );
};
